import { REDIRECT_URLS_REGEX } from '../components/globals';

export function getLoggedInRedirectUrl(
  redirectTo: string | undefined,
  serverLoginRedirect: string | undefined,
): string {
  const hasClientRedirect = redirectTo && redirectTo !== '/';
  const hasServerRedirect = serverLoginRedirect && serverLoginRedirect !== '/';
  if (!hasClientRedirect && hasServerRedirect) {
    return serverLoginRedirect;
  }
  if (hasClientRedirect) {
    if (REDIRECT_URLS_REGEX.test(redirectTo)) {
      return redirectTo;
    }
    return `${redirectTo[0] === '/' ? '' : '/'}${redirectTo}`;
  }
  return '/';
}
